import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Safari from './pages/Safari';
import Chile from './pages/Chile';
import SouthAfrica from './pages/SouthAfrica';
import Dubai from './pages/Dubai';
import Tanzania from './pages/Tanzania';
import Zanzibar from './pages/Zanzibar';
import Mauritius from './pages/Mauritius';
import NotFound from './pages/NotFound';
import { Toaster } from './components/ui/sonner';
import WhatsAppFloat from './components/WhatsAppFloat';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/safari" element={<Safari />} />
          <Route path="/chile" element={<Chile />} />
          <Route path="/south-africa" element={<SouthAfrica />} />
          <Route path="/dubai" element={<Dubai />} />
          <Route path="/tanzania" element={<Tanzania />} />
          <Route path="/zanzibar" element={<Zanzibar />} />
          <Route path="/mauritius" element={<Mauritius />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <WhatsAppFloat />
      </BrowserRouter>
    </div>
  );
}

export default App;
